import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PSF_REASON_FOR_SIGNING = createFcmDetails('psf_reason_for_signing', {
	owner: 'supporters pack',
	context: 'petition page',
	description: 'Indicates whether the reason for signing should be stored in the sessionStorage (non-guests only)',
	import: false,
});
